import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import Flex from "../../components/structure/Flex";
import { FullPageLoading } from "../../components/ui/Loading";
import { AuthContext } from "../../contexts/auth";
import { ZoLogin } from "../ZoLogin";

interface ProtectedPageProps {}

const ProtectedPage: React.FC<ProtectedPageProps> = () => {
  const { isLoggedIn } = useContext(AuthContext);
  const history = useHistory();

  if (isLoggedIn) {
    history.push("/");
  }
  return (
    <>
      {!isLoggedIn && isLoggedIn !== null ? (
        <div>
          <div className="flex flex-col px-4 py-8 bg-accent ">
            <Flex items="center" className="px-2 mb-2 sm:px-0">
              <div className="flex flex-col items-center w-full max-w-xl mx-auto">
                <span className="text-lg font-medium">Live It. Now</span>
                <h1 className="text-3xl font-medium text-orange">Zo Admin </h1>
              </div>
            </Flex>
          </div>
          <ZoLogin />
        </div>
      ) : (
        <FullPageLoading />
      )}
    </>
  );
};

export default ProtectedPage;
